module.exports = __webpack_public_path__ + "static/media/get-moving 2.b433aba4.png";